import {
  JobberWorkerTypeAgencyPrivateViewDTO,
  JobberWorkerTypeDTO,
  JobberWorkerTypeStatus,
} from '../../common/CommonInterfaces';

const isJobberWorkerTypeActive = (
  workerType: JobberWorkerTypeAgencyPrivateViewDTO | JobberWorkerTypeDTO
): boolean => {
  return !workerType.status || workerType.status === JobberWorkerTypeStatus.ACTIVE;
};

const filterActiveJobberWorkerTypes = <T extends JobberWorkerTypeAgencyPrivateViewDTO | JobberWorkerTypeDTO>(
  workerTypes: readonly T[] | null | undefined
): readonly T[] => {
  if (!workerTypes) {
    return [];
  }
  return workerTypes.filter((workerType) => isJobberWorkerTypeActive(workerType));
};

export {
  isJobberWorkerTypeActive,
  filterActiveJobberWorkerTypes,
};
